import gql from 'graphql-tag';

export const sendUrgentCommunication = gql(/* GraphQL */ `
  mutation sendUrgentCommunication($propertyId: UUID!, $subject: String, $body: String!) {
    sendUrgentCommunication(propertyId: $propertyId, subject: $subject, body:$body)
  }
`);